export default __webpack_public_path__ + "static/share-logo-33dcf55c0e2a38aea4f1472f097caace.png";